<template>
  <div>
    <bridge8-popover
      v-if="typeof origin === 'object'"
      trigger="click"
      :obj="locationTableDataCallback(origin)"
      :text-callback="locationDataTextCallback"
      header-prefix="Origin: "
    />
    <span v-else>{{ origin }}</span>
    <span v-if="!!via"><span> - </span>
      <bridge8-popover
        v-if="typeof via === 'object'"
        trigger="click"
        :obj="locationTableDataCallback(via)"
        :text-callback="locationDataTextCallback"
        header-prefix="Via: "
      />
      <span v-else>{{ via }}</span>
    </span>
    <span> - </span>
    <bridge8-popover
      v-if="typeof destination === 'object'"
      trigger="click"
      :obj="locationTableDataCallback(destination)"
      :text-callback="locationDataTextCallback"
      header-prefix="Destination: "
    />
    <span v-else>{{ destination }}</span>
  </div>
</template>

<script>
import Bridge8Popover from './Bridge8Popover'
import { mapState } from 'vuex'

export default {
  name: 'CalcFlightsTableCellRoute',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('calc', {
      locations: state => state.data.locations
    }),
    origin () {
      return this.locations.find(loc => loc.type === 'Airport' && loc.location.name === this.row.origin) || this.row.origin
    },
    via () {
      return this.locations.find(loc => this.row.via ? (loc.type === 'Airport' && loc.location.name === this.row.via) : null) ||
        (this.row.via ? this.row.via : null)
    },
    destination () {
      return this.locations.find(loc => loc.type === 'Airport' && loc.location.name === this.row.destination) || this.row.destination
    }
  },
  methods: {
    locationDataTextCallback (loc) {
      return loc.location.name
    },
    locationTableDataCallback (loc) {
      return Object.assign({}, loc, loc ? loc.location : {})
    }
  },
  components: {
    Bridge8Popover
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcFlightsTableCellRoute.vue